import React, { useState } from 'react';
import RefetchContext from './RefetchContext';

const RefetchWrapper = ({ children }) => {
  const [refetch, setRefetch] = useState(null);
  return (
    <RefetchContext.Provider value={{ refetch: () => refetch, setRefetch }}>
      {children}
    </RefetchContext.Provider>
  );
};

export default RefetchWrapper;
